<template>
  <div class="page-container product-editor">
    <div class="page-title-container">
      <h1 class="page-title">
        {{ editing ? "Editar vendedor" : "Nuevo vendedor" }}
      </h1>
    </div>
    <div class="container px-0">
      <div class="row justify-content-center">
        <div class="col-12">
          <b-card
            tag="article"
            no-body
            style="max-width: 760px"
            class="custom-card"
          >
            <b-card-header
              header-tag="section"
              class="custom-card-header d-flex align-items-center"
            >
              <h3>
                {{
                  editing ? "Datos del vendedor" : "Datos del nuevo vendedor"
                }}
              </h3>
            </b-card-header>
            <b-card-body class="custom-card-body px-0 pb-0">
              <form class="custom-form" @submit.prevent="save" novalidate>
                <div class="form-section pt-0">
                  <h2 class="custom-card-subtitle mb-4">
                    Información personal
                  </h2>
                  <div class="row">
                    <div class="col-12">
                      <div class="form-group mb-0">

                        <label for="seller">Colaborador</label>
                        <FormInput
                          id="name-readonly"
                          type="text"
                          v-if="editing"
                          disabled
                          v-model="name">
                        </FormInput>
                        <SearchableDropdown
                          placeholder="Elegir colaborador"
                          :options="employeeList"
                          v-if="!editing"
                          :oldValue="form.employeeId"
                          @selected="form.employeeId = $event"
                        />
                        <form-error
                          message="Colaborador es requerido"
                          v-if="$v.form.employeeId.$error && !$v.form.employeeId.required"
                        ></form-error>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-section pb-0 border-0">
                  <h2 class="custom-card-subtitle mb-4">Información Laboral</h2>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group mb-0">
                        <label for="zonales">Zonales</label>

                        <b-form-group>
                          <b-form-checkbox-group
                            id="seller-zonal-checkbox-list"
                            v-model="form.zonalIds"
                            :options="zonalList"
                            name="zonales"
                          ></b-form-checkbox-group>
                        </b-form-group>

                        <form-error
                          message="Zonal es requerido"
                          v-if="$v.form.zonalIds.$error && !$v.form.zonalIds.required"
                        ></form-error>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-section border-0 pt-0">
                  <div class="form-group-buttons text-right">
                    <a
                      @click="$router.push({name: 'celulares-sellers-list'})"
                      class="button button-light"
                    >
                      {{ editing ? "Volver" : "Cancelar" }}
                    </a>
                    <button class="button button-primary" type="submit">
                      Guardar
                    </button>
                  </div>
                </div>
              </form>
            </b-card-body>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Alert, Constants, FormError, FormInput, SearchableDropdown } from "wize-admin";

import { EmployeeService } from "@/core/services";

import { required, requiredIf } from "vuelidate/lib/validators";
import { Constants as LocalConstants } from "@/core/utils";
import geoDataMixin from "@/core/Mixins/geoDataMixin";

export default {
  mixins: [geoDataMixin],
  data() {
    return {
      zonalList: [],
      employeeList: [],
      name: null,
      form: {
        employeeId: null,
        zonalIds: [],
      },
      editing: false,
    };
  },
  components: {
    FormError,
    SearchableDropdown,
    FormInput
  },
  validations: {
    form: {
      employeeId: {required: requiredIf(function () {
          return (
            !this.editing
          );
        })
      },
      zonalIds: {required},
    },
  },
  watch: {
    "$route.params.id": function () {
      if (this.$route.params.id) this.load(this.$route.params.id);
    },
  },
  methods: {
    async save() {
      this.$v.$touch();

      if (this.$v.$error) {
        this.$nextTick(() => {
          this.$smoothScroll({
            scrollTo: document.querySelector(".form-error"),
            updateHistory: false,
            offset: -50,
          });
        });
        return;
      }

      this.$store.dispatch("app/loading", true);
      const data = {
        zonalIds: this.form.zonalIds,
        position: LocalConstants.EmployeePosition.SELLER.key,
      };

      try {
        let response;
        if (!this.editing) {
          response = await EmployeeService.save(this.form.employeeId, data);
        } else {
          response = await EmployeeService.update(this.$route.params.id, data);
        }

        if (response.status == "OK") {
          Alert.success("Se almacenó la información correctamente");
          if (!this.editing) {
            this.$router.push({
              name: "celulares-sellers-edit",
              params: {id: response.payload.id},
            });
            this.editing = true;
          }
        }
      } catch (ex) {
        Alert.error(ex.errors.message);
      } finally {
        this.$store.dispatch("app/loading", false);
      }
    },
    async load(id) {
      try {
        this.$store.dispatch("app/loading", true);
        const response = await EmployeeService.get(id);
        this.name = response.payload.label;
        const zonalIds = response.payload.zonales.map((zonal) => zonal.id);
        this.form.zonalIds = zonalIds;
        this.editing = true;
      } catch (ex) {
        console.error(ex);
        let message = ex.errors.message;
        if (message === "No encontrado")
          message = Constants.Errors.RECORD_NOT_FOUND;
        Alert.error(message, () =>
          this.$router.push({name: "celulares-sellers-list"})
        );
      } finally {
        this.$store.dispatch("app/loading", false);
      }
    },
  },
  async created() {
    if (this.$route.params.id) await this.load(this.$route.params.id);

    await this.getZonalList()
    await this.getAvailableEmployees()

    this.zonalList = this.zonalList.map((zonal) => {
      return {
        value: zonal.key,
        text: zonal.label
      };
    });
  },
};
</script>

<style lang="stylus">
@import "../Styles/seller-editor.styl"
</style>
